import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import { useHistory } from 'react-router-dom';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Error, Success } from '../Alert/index';
import api from '../../services/api';

export function ListCollege () {
  const history = useHistory();
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const [colleges, setColleges] = useState([]);

  // Busca lista de usuários
  useEffect(() => {
    api.get('/colleges')
      .then((res) => {
        setColleges(res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        }
      });
  }, [history]);

  function addCollege (newValue) {
    api.post('/colleges', { name: newValue.name, realm: newValue.realm })
      .then((res) => {
        setColleges(res.data);
        setSuccess(true);
        document.getElementById('msgSuccess').innerHTML = 'Instituição cadastrada com sucesso!';
        setTimeout(() => setSuccess(false), 3000);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        } else {
          setError(true);
          document.getElementById('msgError').innerHTML = err.response.data.error;
          setTimeout(() => setError(false), 3000);
        }
      });
  }

  function updateCollege (newValue, oldValue) {
    api.put('/colleges', {
      college: newValue,
    })
      .then((res) => {
        setColleges(res.data);
        setSuccess(true);
        document.getElementById('msgSuccess').innerHTML = 'Instituição atualizada com sucesso!';
        setTimeout(() => setSuccess(false), 3000);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        } else {
          setError(true);
          document.getElementById('msgError').innerHTML = err.response.data.error;
          setTimeout(() => setError(false), 3000);
        }
      });
  }

  function deleteCollege (oldValue) {
    api.delete(`/colleges/${oldValue._id}`)
      .then((res) => {
        setColleges(res.data);
        setSuccess(true);
        document.getElementById('msgSuccess').innerHTML = 'Instituição removida com sucesso!';
        setTimeout(() => setSuccess(false), 3000);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        } else {
          setError(true);
          document.getElementById('msgError').innerHTML = err.response.data.error;
          setTimeout(() => setError(false), 3000);
        }
      });
  }

  function collegesUpdate () {
    api.get('/colleges')
      .then((res) => {
        setColleges(res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        }
      });
  }
  return (
    <div className="content-list">
      {error ? <Error><p id="msgError" /></Error> : null}
      {success ? <Success><p id="msgSuccess" /></Success> : null}
      <section className="update">
        <div
          className="update-table"
          onClick={collegesUpdate}
          aria-hidden="true"
        >
          <p>Atualizar</p>
          <FontAwesomeIcon icon={faSyncAlt} size="lg" color="white" />
        </div>
      </section>
      <MaterialTable
        title="Instituições"
        columns={[
          { title: 'Nome', field: 'name' },
          { title: 'Realm', field: 'realm' },
        ]}
        localization={{
          header: {
            actions: 'Oções',
          },
          body: {
            emptyDataSourceMessage: 'Sem dados para mostrar',
            deleteTooltip: 'Remover',
            addTooltip: 'Adicionar Instituição',
            editTooltip: 'Editar',
            editRow: {
              cancelTooltip: 'Cancelar',
              deleteText: 'Tem certeza que deseja remover',
              saveTooltip: 'Confirmar',
            },

          },
          toolbar: {
            searchPlaceholder: 'Buscar',
            searchTooltip: 'Buscar',
          },
        }}
        data={colleges}
        editable={{
          onRowAdd: (newData) => new Promise((resolve) => {
            addCollege(newData);
            setTimeout(() => resolve(), 2000);
          }),
          onRowUpdate: (newValue, oldValue) => new Promise((resolve) => {
            updateCollege(newValue, oldValue);
            setTimeout(() => resolve(), 2000);
          }),
          onRowDelete: (oldValue) => new Promise((resolve) => {
            deleteCollege(oldValue);
            setTimeout(() => resolve(), 2000);
          }),
        }}
      />
    </div>
  );
}
